export default "__VITE_ASSET__BH1AsAz0__"